<script module>
  export const i18n = {
    sv: {
      Decrease: 'Minska',
      Increase: 'Öka'
    },
    da: {
      Decrease: 'Mindske',
      Increase: 'Forøge'
    }
  }
</script>

<script>
  import { register } from '$lib/utils/text.svelte.js'
  import Symbol from '$lib/Symbol.svelte'

  let text = register(i18n)

  /**
   * @type {{
   *   name: string,
   *   max?: number,
   *   min?: number,
   *   value?: number,
   *   size?: 'sm'|'md'|'lg',
   *   onchange?: function(number): void,
   *   children?: Svelte.Snippet,
   *   [key: string]: any
   * }}
   */
  let {
    name,
    max,
    min = 0,
    value = 0,
    size,
    onchange,
    children,
    ...attrs
  } = $props()

  // Don't understand why this is needed but for some reason it just is
  let increase = $derived(text`Increase`)
  let decrease = $derived(text`Decrease`)

  const onclick = (next) => (event) => {
    value = next
    onchange?.(next)
    event.preventDefault()
  }
</script>

<div class="counter" class:sm={size === 'sm'} class:lg={size === 'lg'}>
  {#if children}
    {@render children()}
  {/if}
  <div class="toggles">
    <button
      {...attrs}
      {name}
      class="minus"
      type="submit"
      value={value - 1}
      title={decrease}
      disabled={value === min}
      onclick={onclick(value - 1)}>
      <Symbol name="minus" {size} />
    </button>
    <output class="value" class:active={value}>
      {value}
    </output>
    <button
      {...attrs}
      {name}
      class="plus"
      type="submit"
      value={value + 1}
      title={increase}
      disabled={value === max}
      onclick={onclick(value + 1)}>
      <Symbol name="plus" {size} />
    </button>
  </div>
</div>

<style>
  .counter {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    user-select: none;
  }

  .toggles {
    display: flex;
  }

  .value,
  .minus,
  .plus {
    width: 2.625rem;
    height: 2.625rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    font-weight: 500;
  }

  .sm .value,
  .sm .minus,
  .sm .plus {
    width: 2rem;
    height: 2rem;
    font-size: 1rem;
  }

  .lg .value,
  .lg .minus,
  .lg .plus {
    width: 3rem;
    height: 3rem;
    font-size: 1.25rem;
  }

  .value,
  .minus,
  .plus {
    width: 3rem;
    height: 3rem;
    font-size: 1.25rem;
  }

  .value {
    background: rgb(var(--rgb-muted));
    margin: 0 0.75rem;
    color: #fff;
    border: 0;
    box-shadow: none;
    -webkit-appearance: none;
    appearance: none;
    padding: 0;
    text-align: center;
    -moz-appearance: textfield;
    pointer-events: none;
  }

  .value.active {
    background: rgb(var(--rgb-secondary, var(--rgb-blue)));
  }

  .minus,
  .plus {
    border: 1px solid rgba(var(--rgb-muted), 0.25);
    color: rgb(var(--rgb-dark-gray), 0.7);
    background: #fff;
    box-shadow: var(--box-shadow-sm);
    transition: var(--box-shadow-transition);
  }

  .minus:hover,
  .plus:hover {
    box-shadow: var(--box-shadow-sm-hover);
  }

  .minus:active,
  .plus:active {
    transition: var(--box-shadow-active-transition), var(--transition);
    box-shadow: var(--box-shadow-sm-active);
  }

  .plus:disabled,
  .minus:disabled {
    color: rgba(var(--rgb-muted), 0.4);
    box-shadow: none;
  }

  .minus:disabled,
  .plus:disabled {
    cursor: not-allowed;
  }
</style>
